import { Stack } from "./stack";

// Style me anyway required, but use it on every page to keep same layout
export const PageTemplate = ({ children }: any) => {

  return (
    <Stack>
      <Stack style={{ padding: 20 }}>
        {children}
      </Stack>
    </Stack>
  )
}